import { faMapMarkerAlt } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import MarkdownComponent from 'components/shared/MarkdownComponent';
import { useI18n } from 'hooks/useI18n';
import { StyledJobOfferLongText } from '../JobOfferLongText.styled';
import {
  StyledWhereOffice,
  StyledWhereOfficeAddress,
  StyledWhereOfficeLink,
  StyledWhereOfficeLogo,
  StyledWhereOfficeTitle
} from './WhereOffice.styled';

const WhereOffice = ({
  companyLogo,
  companyAddress,
  googleMaps,
  migratedToMarkdown
}: {
  migratedToMarkdown: boolean;
  companyLogo?: string;
  companyAddress: string;
  googleMaps: string;
}) => {
  const { t } = useI18n('job-offer');

  return (
    <StyledWhereOffice>
      <StyledWhereOfficeLogo src={companyLogo} />
      <StyledWhereOfficeTitle>
        {t('where.officeLocated')}
      </StyledWhereOfficeTitle>
      <StyledWhereOfficeAddress>
        {migratedToMarkdown ? (
          <StyledJobOfferLongText>
            <MarkdownComponent content={companyAddress || ''} />
          </StyledJobOfferLongText>
        ) : (
          <span
            dangerouslySetInnerHTML={{ __html: companyAddress || '' }}
          ></span>
        )}
      </StyledWhereOfficeAddress>
      <StyledWhereOfficeLink
        href={googleMaps}
        target="_blank"
        rel="noreferrer noopener"
      >
        <FontAwesomeIcon icon={faMapMarkerAlt} />
        <span
          dangerouslySetInnerHTML={{ __html: t('where.googleMaps') || '' }}
        ></span>
      </StyledWhereOfficeLink>
    </StyledWhereOffice>
  );
};

export default WhereOffice;
